import React from 'react'

const Lists = () => {
  return (
    <div>Lists</div>
  )
}

export default Lists